var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "bv-modal-examples",
      "size": "lg",
      "hide-footer": true,
      "hide-header": true,
      "no-close-on-esc": true,
      "no-close-on-backdrop": true,
      "centered": "",
      "header-class": "my-class",
      "body-class": "p-0"
    }
  }, [_c('b-card', {
    staticClass: "card-custom-class"
  }, [_c('div', {
    staticClass: "closemodel"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$bvModal.hide('bv-modal-examples');
      }
    }
  }, [_c('span', [_c('img', {
    attrs: {
      "src": "img/address/close.png",
      "alt": ""
    }
  })])])]), _c('span', {
    staticClass: "change-location-text"
  }, [_vm._v(_vm._s(_vm.$t("viewAddress.changeAddress")) + " ")]), _c('span', {
    staticClass: "add-new-address-text",
    on: {
      "click": _vm.addAddress
    }
  }, [_vm._v(_vm._s(_vm.$t("viewAddress.addnewAddress")) + " ")])]), _c('b-list-group', {
    staticClass: "list-group-modal"
  }, _vm._l(_vm.deliveryAddress, function (adderss, index) {
    return _c('b-card', {
      key: index,
      staticClass: "card-custom-class",
      attrs: {
        "body-class": "body-class-modal"
      }
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('b-card-text', [_c('b-form-radio', {
      attrs: {
        "value": true,
        "name": "radio-size",
        "size": "lg"
      },
      on: {
        "change": function ($event) {
          return _vm.changeRadio(adderss);
        }
      },
      model: {
        value: adderss.isDefault,
        callback: function ($$v) {
          _vm.$set(adderss, "isDefault", $$v);
        },
        expression: "adderss.isDefault"
      }
    }, [_c('span', {
      staticClass: "address-name"
    }, [_vm._v(_vm._s(adderss.fullName))]), adderss.isDefault ? _c('span', {
      staticClass: "default-address-class"
    }, [_vm._v(" " + _vm._s(_vm.$t("viewAddress.default")) + " ")]) : _vm._e()])], 1)], 1), _c('b-col', {
      attrs: {
        "cols": "6"
      }
    }, [_vm.$store.state['address'].deleteAddressLoading != adderss._id ? _c('span', {
      staticClass: "float-right"
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "src": "img/address/Trash.png",
        "alt": ""
      },
      on: {
        "click": function () {
          return _vm.deleteAddress(adderss._id);
        }
      }
    }), _c('img', {
      staticClass: "edit-icon-style",
      attrs: {
        "src": "img/EditIcon.png",
        "alt": ""
      },
      on: {
        "click": function () {
          _vm.editAddressClick(adderss);
          _vm.$bvModal.show(adderss._id);
        }
      }
    }), _c('b-modal', {
      attrs: {
        "id": adderss._id,
        "size": "lg",
        "hide-footer": true,
        "hide-header": true,
        "no-close-on-esc": true,
        "no-close-on-backdrop": true,
        "centered": "",
        "header-class": "my-class",
        "body-class": "p-0"
      }
    }, [_vm.$options.components['address-edit-address-modal'] ? [_c('address-edit-address-modal', {
      attrs: {
        "address": adderss
      }
    })] : _vm._e()], 2)], 1) : _vm._e(), _vm.$store.state['address'].deleteAddressLoading == adderss._id ? _c('span', {
      staticClass: "float-right"
    }, _vm._l(3, function (i) {
      return _c('b-spinner', {
        key: i,
        staticClass: "mr-1",
        attrs: {
          "small": "",
          "label": "Small Spinner",
          "type": "grow"
        }
      });
    }), 1) : _vm._e()])], 1), _c('b-col', {
      attrs: {
        "md": "12"
      }
    }, [_c('b-card-text', {
      staticClass: "address-details-text"
    }, [_vm._v(_vm._s(adderss.houseNumber) + ", " + _vm._s(adderss.street1) + ", " + _vm._s(adderss.street2) + ", " + _vm._s(adderss.city) + ", " + _vm._s(adderss.state) + ", " + _vm._s(adderss.zip) + " ")])], 1)], 1);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }